import { useState } from "react"
import AddTodo from "./AddTodo";
import Todolist from "./Todolist";
function Todocontainer() {  
    const [mylist,setmylist] = useState([{id:1,activity:"Go for a walk"},{id:2,activity:"Have a breakfast"}])  
    return (<div>
        <div className="flex py-5 gap-7 flex-wrap">
            <AddTodo mylist={mylist} setmylist={setmylist}/>           
            <Todolist mylist={mylist} setmylist={setmylist}/>
        </div>
    </div>)
}
export default Todocontainer